import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  button: {
    margin: '10px 20px',
    background: 'linear-gradient(-30deg, #6C63FF 30%, #554fcc 90%)',
    color: 'white'
  }
});

export default useStyles;
